import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCode,
  faLaptopCode,
  faServer,
  faMobileScreenButton,
  faPenRuler,
} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  return (
    <article className="about active">
      <header>
        <h2 className="h2 article-title">About me</h2>
      </header>

      <section className="about-text">
        <p>
          Hi, I’m Ephraim Emmanuel, a Full Stack Developer specializing in the
          MERN stack, with a degree in Electrical and Electronics Engineering
          from the Federal University of Agriculture, Abeokuta (FUNAAB),
          Nigeria. My engineering background has shaped the way I approach
          software development, with a strong focus on problem-solving, logical
          thinking, and building practical solutions. I enjoy turning ideas into
          responsive, intuitive, and scalable web applications.
        </p>

        <p>
          I have experience developing both frontend and backend systems,
          working with technologies including JavaScript, React, Node.js,
          MongoDB, PostgreSQL, Git, and GitHub. Throughout my development
          journey, I’ve worked on a variety of projects, from business and
          corporate websites to web applications, gaining hands-on experience
          with modern development workflows and real-world requirements.
        </p>

        <p>
          I’m particularly interested in building products that combine clean
          user interfaces, reliable backend systems, and thoughtful
          functionality. I’m continuously expanding my skills and exploring new
          technologies while improving how I design, develop, and deploy
          software. I’m always open to opportunities to build, collaborate,
          learn, and solve meaningful problems through technology.
        </p>
      </section>

      {/* SKILLS */}
      <header>
        <h3 className="h3 article-title">Skills:</h3>
      </header>

      <section className="about-text">
        <p>
          Full Stack Development, MERN Stack (MongoDB, Express.js, React,
          Node.js), RESTful API Development, Database Design (MongoDB,
          PostgreSQL), Frontend Development (React, Next.js, TypeScript),
          Backend Development, Version Control (Git, GitHub), Responsive Web
          Design, User Interface Design.
        </p>
      </section>

      {/* OTHER SKILLS */}
      <header>
        <h3 className="h3 article-title">Other Skills:</h3>
      </header>

      <section className="about-text">
        <p>
          Project Management, Agile Methodologies, Code Review, Technical
          Documentation, Problem Solving, Team Collaboration, Graphic Design
          (Adobe Photoshop), UI/UX Design (Figma), Cross-platform Mobile
          Development (React Native).
        </p>
      </section>

      {/* SERVICES */}
      <section className="service">
        <h3 className="h3 service-title">What I'm doing</h3>

        <ul className="service-list">
          {/* FULL STACK */}
          <li className="service-item">
            <div className="service-icon-box">
              <FontAwesomeIcon
                icon={faCode}
                className="service-icon"
                aria-hidden="true"
              />
            </div>

            <div className="service-content-box">
              <h4 className="h4 service-item-title">
                Full Stack Web Development
              </h4>

              <p className="service-item-text">
                Building complete web applications with the MERN stack, from
                database design and backend APIs to responsive frontend
                interfaces.
              </p>
            </div>
          </li>

          {/* FRONTEND */}
          <li className="service-item">
            <div className="service-icon-box">
              <FontAwesomeIcon
                icon={faLaptopCode}
                className="service-icon"
                aria-hidden="true"
              />
            </div>

            <div className="service-content-box">
              <h4 className="h4 service-item-title">Frontend Development</h4>

              <p className="service-item-text">
                Creating responsive and interactive interfaces with React,
                Next.js, TypeScript, and Tailwind CSS.
              </p>
            </div>
          </li>

          {/* BACKEND */}
          <li className="service-item">
            <div className="service-icon-box">
              <FontAwesomeIcon
                icon={faServer}
                className="service-icon"
                aria-hidden="true"
              />
            </div>

            <div className="service-content-box">
              <h4 className="h4 service-item-title">Backend Development</h4>

              <p className="service-item-text">
                Developing secure and scalable RESTful APIs with Node.js,
                Express.js, MongoDB, PostgreSQL, and Redis.
              </p>
            </div>
          </li>

          {/* MOBILE */}
          <li className="service-item">
            <div className="service-icon-box">
              <FontAwesomeIcon
                icon={faMobileScreenButton}
                className="service-icon"
                aria-hidden="true"
              />
            </div>

            <div className="service-content-box">
              <h4 className="h4 service-item-title">Mobile Development</h4>

              <p className="service-item-text">
                Developing cross-platform mobile applications for iOS and
                Android using React Native.
              </p>
            </div>
          </li>

          {/* UI/UX */}
          <li className="service-item">
            <div className="service-icon-box">
              <FontAwesomeIcon
                icon={faPenRuler}
                className="service-icon"
                aria-hidden="true"
              />
            </div>

            <div className="service-content-box">
              <h4 className="h4 service-item-title">UI/UX & Graphic Design</h4>

              <p className="service-item-text">
                Designing clean user interfaces and digital assets using Figma
                and Adobe Photoshop.
              </p>
            </div>
          </li>
        </ul>
      </section>
    </article>
  );
};

export default About;
